// Misc
import React, { Component } from 'react'
import PropTypes from 'prop-types'

// Constants
import { EMAIL, TEXT, FIRST_NAME, LAST_NAME, PHONE, WORKFLOWMAX_COMPANY } from 'constants/proposalCustomerFieldTypes'

// Atoms
import Chip from 'atoms/Chip'

export default class CustomerField extends Component {
  static propTypes = {
    field: PropTypes.shape({
      type: PropTypes.string.isRequired,
      label: PropTypes.string,
    }),
    onDelete: PropTypes.func,
  }

  state = {
    dialogOpen: false,
  }

  toggleDialog = () => {
    const { dialogOpen } = this.state
    this.setState({ dialogOpen: !dialogOpen })
  }

  renderFieldContent() {
    const { field } = this.props
    switch (field.type) {
      case TEXT:
        return field.label
      case EMAIL:
        return 'Email'
      case FIRST_NAME:
        return 'First name'
      case LAST_NAME:
        return 'Last name'
      case PHONE:
        return 'Phone'
      case WORKFLOWMAX_COMPANY:
        return 'Company name'
      default:
        return null
    }
  }

  render() {
    const { onDelete } = this.props
    const content = this.renderFieldContent()
    return !!content && (
      <Chip onDelete={onDelete} clickable={false}>
        { content }
      </Chip>
    )
  }
}
